import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { fillUANForm } from "../store/pdfdata/pdfdataSlice";
import ColorCheckFun from "./ColorCheckFun";
import ColorCode from "./ColorCode";
import RecursiveModal from "./RecursiveModal";
import SummaryRemarks from "./SummaryRemarks";

const UAN = ({ annexure }) => {
  const UANForms = useSelector(
    (state) => state.pdfdata.forms["UAN Verification"]
  );
  const dispatch = useDispatch();
  const execSummary = useSelector((state) => state.pdfdata.executiveSummary);
  const addVal = (e, table) => {
    e.preventDefault();
    dispatch(fillUANForm([table, e.target.name, e.target.value]));
    if (e.target.name === "Color Code")
      ColorCheckFun(dispatch, execSummary, table, e.target.value);
  };
  return (
    <div>
      <h3 className="text-center mt-4">
        <u>UAN Verification</u>
      </h3>
      {Object.keys(UANForms).map((table, index) => (
        <table key={table}>
          {Object.keys(UANForms[table]).map((row) => (
            <tr>
              <td>{row}</td>
              {row === "Color Code" ? (
                <ColorCode
                  namefield={row}
                  cls={UANForms[table][row]}
                  fun={(e) => addVal(e, table)}
                  spanNum={2}
                />
              ) : (
                <td style={{ backgroundColor: "white" }}>
                  <textarea
                    style={{ width: "100%", height: 30 }}
                    type="text"
                    name={row}
                    defaultValue={UANForms[table][row]}
                    onBlur={(e) => {
                      addVal(e, table);
                    }}
                  />
                </td>
              )}
            </tr>
          ))}
          <tr>
            <td>Upload Document</td>
            <td colSpan={1}>
              <RecursiveModal
                mainTable="UAN Verification"
                subTable={table}
                annexure={annexure + (index + 1)}
              />

              <span className="alert">
                Files of format .jpg, .jpeg, .png, .eml are accepted!
              </span>
            </td>
          </tr>
          <SummaryRemarks
            type="UAN Verification"
            namefield={table}
            spanNum={1}
          />
          <tr>
            <td colSpan={2}>
              Please Refer{" "}
              <b>
                Annexure-{annexure}
                {index + 1}
              </b>
            </td>
          </tr>
        </table>
      ))}
    </div>
  );
};
export default UAN;
